// let { Log } = require('./v2log.js');

import Log from './v2log.js';
import sg from './storage.js';

let choicesys = sg.getStorage('choicesys') || '';
let userinfo = sg.getStorage('userinfo') || {};
let uuid = sg.getStorage('uuid') || '';
let from = sg.getStorage('from') || '';
// let activity = sg.getStorage('activity') || '';

const config = {
  debug: false, // 上报打印数据开光，调试用，默认false，
  // 上报处理方法：可取的值为 miniProgramReport,gappReport,webReport, 分别对应小程序上报，gappH5上报，普通web上报
  // 可选参数，若不传，则根据 UA 或者 window.wx 等变量自动判读当前运营环境，调用对应的上报方法
  reportHandlerType: '',
  // commonInfo, 通用信息，如用户信息，当前设备环境信息，不会变更的的信息在此传入，则后续每次上报会自动带上commonInfo里的信息，
  // 注意: commonInfo 字段必须在该字段列表里面 https://km.qutoutiao.net/pages/viewpage.action?pageId=69554316#id-01.%E5%9F%8B%E7%82%B9%E5%B9%B3%E5%8F%B0%E6%80%BB%E4%BD%93%E8%AE%BE%E8%AE%A1-%E9%80%9A%E7%94%A8%E5%B1%9E%E6%80%A7
  // 以下字段都非必填字段，可以根据当前环境能获取到的信息填入，获取不到信息的字段，则可从commonInfo中移除
  commonInfo: {
    app: 'hhxxl-h5', // 可在初始化指定，也可以在上报调用report时指定
    device: '',
    android_id: '',
    tuid: '',
    tk: '',
    mid: userinfo.order || '',
    uuid,
    app_version: '', //APP版本
    os_version: '', //手机系统版本
    device_mode: '', //手机型号
    device_manu: '', //手机厂商
    device_brand: '', //手机品牌
    screen_width: '',
    screen_height: '',
    system: choicesys,
    device_carrier: '', //手机运营商	电信、移动、联通
    dtu: from, //来源渠道
    network: '', //网络3g、4g、5g、wifi
    lat: '', // 纬度，保留6位小数
    lon: '', //经度，保留6位小数
    app_subversion: '', // 客户端小版本号
    extend_info: {
      system: choicesys,
      uuid
      // user_id: userinfo.order || '',
      // activity_id: activity.id || '',
      // activity_name: activity.name || ''
    }
  }
};

export default new Log(config);
